import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';
import { observer } from 'mobx-react';
import isEqual from 'lodash/isEqual';

import Image from '../shared/Image';
import Text from '../shared/Text';
import IconButton from '../shared/IconButton';
import { getDynamicStyles } from './Body';

import { countHp, inCombat as heroInCombat, isQuick } from '../../utils/warriorUtils';
import { t } from '../../utils/appUtils';

import warriorInfoModalStore from './WarriorInfoModal/store';

import { HP_HEIGHT, pOrT } from '../styleConstants';
import SignUpModal from '../SignUpModal';

import { WarriorType, WarriorHpType } from '../../lib/types';

const styles = StyleSheet.create({
  wrapper: {
    height: HP_HEIGHT,
  },
  nameWrapper: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  name: {
    fontSize: pOrT(16, 16),
    marginTop: pOrT(0, 2),
    color: '#9a7861',
  },
  level: {
    color: '#9a7861',
    fontSize: pOrT(10, 12),
    marginTop: pOrT(5, 7),
  },
  hpTextWrapper: {
    position: 'absolute',
    right: 0,
    top: pOrT(7, 9),
  },
  hpWrapper: {
    position: 'absolute',
    top: pOrT(21, 28),
  },
  hp: {
    height: 2,
    backgroundColor: '#FF8080',
  },
  hpText: {
    fontSize: pOrT(9, 12),
    color: '#f5d3b8',
  },
  info: {
    marginTop: 5,
    marginLeft: 2,
  },
});

type Props = {
  warrior: WarriorType;
  showInfo?: boolean;
  height?: number;
  showQuickSignUp?: boolean;
  inCombat?: boolean;
};

type State = {
  showSignUpModal: boolean;
  currentHp: number;
};

@observer
export default class Hp extends Component<Props, State> {
  setHpInterval: any = null;

  currentHpObj: WarriorHpType;

  constructor(props: Props) {
    super(props);

    const { current } = props.warrior.feature.hp!;

    this.currentHpObj = props.warrior.feature.hp!;

    this.state = {
      showSignUpModal: false,
      currentHp: current,
    };
  }

  componentDidMount() {
    this.countHp();
  }

  componentDidUpdate() {
    const { warrior } = this.props;
    const { hp } = warrior.feature;

    if (!isEqual(this.currentHpObj, hp)) {
      this.currentHpObj = hp!;
      if (heroInCombat(warrior)) this.setHp(hp);
      this.countHp();
    }
  }

  componentWillUnmount() {
    clearInterval(this.setHpInterval);
  }

  setHp = (hp?: WarriorHpType) => {
    const { warrior } = this.props;
    const { currentHp } = this.state;
    hp = hp || countHp(warrior.feature.hp!);

    if (hp.current !== currentHp) {
      this.setState({
        currentHp: hp.current,
      });
    }

    if (hp.max === hp.current) {
      clearInterval(this.setHpInterval);
      this.setHpInterval = null;
    }
  };

  toggleSignUpModal = () => {
    this.setState((state) => ({
      showSignUpModal: !state.showSignUpModal,
    }));
  };

  countHp() {
    const { warrior } = this.props;
    if (heroInCombat(warrior)) return;

    if (!this.setHpInterval) {
      this.setHpInterval = setInterval(this.setHp, 1000);
      this.setHp();
    }
  }

  render() {
    const { warrior, showInfo, height, showQuickSignUp } = this.props;
    const { currentHp } = this.state;
    const { showSignUpModal } = this.state;

    const { hp } = warrior.feature;
    const hpReady = currentHp / hp!.max;

    const width = getDynamicStyles(height).FULL_WIDTH;
    return (
      <View style={[styles.wrapper, { width }]}>
        <View style={styles.nameWrapper}>
          {showQuickSignUp && isQuick(warrior) && (
            <IconButton
              name="signUp"
              size={24}
              title={t('auth.signUp')}
              iconStyle={pOrT(
                {
                  width: 20,
                  height: 20,
                },
                {
                  width: 22,
                  height: 22,
                },
              )}
              style={{ marginRight: 4, marginTop: pOrT(0, 3) }}
              source={require('../../assets/images/addPerson.png')}
              onPress={this.toggleSignUpModal}
            />
          )}
          <Text selectable bold style={styles.name}>
            {warrior.login}
          </Text>
          <Text bold style={styles.level}>
            {' '}{`[${warrior.level}]`}
          </Text>
          {showInfo ? (
            <IconButton
              style={styles.info}
              iconStyle={pOrT(
                {
                  width: 16,
                  height: 16,
                },
                {
                  width: 18,
                  height: 18,
                },
              )}
              source={require('../../assets/images/info.png')}
              onPress={() => warriorInfoModalStore.toggle(warrior.id, true)}
              size={12}
              name="info"
              title={t('hero.info')}
            />
          ) : null}
        </View>
        <View style={styles.hpTextWrapper}>
          <Text bold style={styles.hpText}>
            {`[${currentHp} / ${hp!.max}]`}
          </Text>
        </View>
        <View style={styles.hpWrapper}>
          <View style={{ width: width * hpReady, overflow: 'hidden' }}>
            <Image
              style={{ width, height: pOrT(6, 8) }}
              source={require('../../assets/images/hpLine.png')}
            />
          </View>
        </View>

        {showSignUpModal && <SignUpModal quick onHide={this.toggleSignUpModal} />}
      </View>
    );
  }
}
